<template>
  <div id="content" class="where_to_innovate_finder">
    <div class="messagepromopubContainerBandeau">
      <div class="messagepromopub">
        Broaden innovation reach
        <a href="https://outlook.office365.com/book/innopearl@innopearl.ch/" target="_blank" class="bluehover"><strong>Leverage our scouting expertise</strong></a>
      </div>
    </div>
    <StartupRunAssessment @close="runassessment=false" :dialogVisible="runassessment"
     @newInternal="newInternal"
     @newInnopearl="newInnopearl"
     @existingInternal="existingInternal">
    </StartupRunAssessment>
    <AddToListModal  :dialogVisible='dialoglist'  @close="dialoglist = false" @toExisting="toExisting($event)"></AddToListModal>

    <CreateListModal  :dialogVisible='dialogCreateList'  @close="dialogCreateList = false" @createList="createList($event)"></CreateListModal>

    <div class="ai_loader" v-if="pearlAI_reflexion">
      <div class="ai_loader_in">
        <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
        <div class="ai_loader_text">
          Please wait while PearlAI ​​analyzes the data.
        </div>
      </div>
    </div>
    <div class="content_div">
      <div class="sidePannel" v-if="showSidePanelBasic == true">

        <div class="filters">


          <div class="oneFilter" v-for="(filtre,f) in basicFilters" :key="f">
            <span class="filtreName clickable" @click="filtre.toggled_sidebar = !filtre.toggled_sidebar">
              {{filtre.display_name}}<span v-if="filtre.key =='revenue' "> (millions)</span>
              <sup class="nb_item" v-if="filtre.values.length > 0">{{filtre.values.length}}</sup>
              <sup class="nb_item" v-else-if="filtre.values.min > 0 || filtre.values.max > 0">1</sup>
              <sup class="nb_item" v-else-if="filtre.values.from || filtre.values.to">1</sup>
              <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(filtre.toggled_sidebar == true) ? "open" : "not-open"' alt="">
            </span>
            <div v-if="filtre.toggled_sidebar == true">

            <div class="" v-if="filtre.key =='submitDate' ">
              <div class="moneyEntryLine">
                <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.from"/>
              </div>
              <div class="moneyEntryLine">
                <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.to"/>
              </div>
            </div>
            <div class="" v-else-if="filtre.key =='revenue' ">
                <div class="moneyEntryLine">
                  <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.min"/>
                </div>
                <div class="moneyEntryLine">
                  <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.max"/>
                </div>
                <!-- <div class="moneyEntryLine">
                  <span class="moneyEntryName">Unit</span>
                  <select class="moneyEntryInput input_filtre" name=""  v-model="filtre.values.unit">

                    <option value="M">M</option>

                  </select>
                </div> -->
                <!-- <div class="moneyEntryLine">
                  <span class="moneyEntryName">Currency </span>
                  <select class="moneyEntryInput input_filtre" name=""  v-model="filtre.values.devise">
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                    <option value="CHF">CHF</option>
                  </select>
              </div> -->


            </div>
            <div class="" v-else-if="filtre.key =='linkplus' ">
            <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

            <div class="value_possible">
              <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                <div class="checkboxItem"  v-if="val.name.toUpperCase().includes(filtre.filtre.toUpperCase())">


                  <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val._id.$oid"/>
                  <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                    <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                    <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                  </svg>
                  <span class="checkbox__label">{{val.name}}</span>
                        </div>
                </label>

            </div>
          </div>
            <div class="" v-else>
            <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

            <div class="value_possible">
              <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                <div class="checkboxItem"  v-if="val.value.toUpperCase().includes(filtre.filtre.toUpperCase())">


                  <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val.value"/>
                  <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                    <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                    <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                  </svg>
                  <span class="checkbox__label">{{val.name}}</span>
                        </div>
                </label>

            </div>
          </div>
          </div>
          </div>
        </div>
        <div class="footerPannel">
            <button type="button" name="button" class="btn_invert" @click="showSidePanelBasic = false">Close</button>
            <button type="button" @click="reset_bfilter()" class="btn_invert" name="button">Reset filters</button>

            <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
        </div>

      </div>
      <!-- <div class="header topicInfo">
        <div class="tt"><span class="tt_label">TOPIC :</span> <span class="tt_value">{{topicTitle}}</span></div>
        <div class="topicScore" v-if="topicScore">

          <div class="one_topic_interest high" v-if="topicScore >= 8">
                STRONGEST FIT
          </div>
          <div class="one_topic_interest medium" v-else-if="topicScore >= 5">
                STRONG FIT
          </div>
          <div class="one_topic_interest low" v-else>
                MODERATE FIT
          </div>
        </div>
      </div> -->
      <div class="inner ">
        <div class="" v-if="sessionId && debugerPeople.includes(userInfo._id.$oid)">
          <small>Session ID : {{sessionId}}</small>
        </div>
        <div class="title">
          POTENTIAL PARTNERS FOR "{{topicTitle}}"

        </div>
        <div class="startup_notice_info">
          This list is not an exhaustive market analysis. More innovators may be identified in Innopearl’s database or through scouting.

        </div>
        <div class="main_action_zone">
          <button type="button" class="see_the_brief_button" name="button" @click="show_brief = !show_brief" v-if="show_brief == false">VIEW THE BRIEF</button>
          <button type="button" class="see_the_brief_button" name="button" @click="show_brief = !show_brief" v-if="show_brief == true">HIDE THE BRIEF</button>

        </div>
        <div class="messages" v-if="show_brief == true">
                <div>
                  <div class="message_brief" v-if="brief">
                    <div class="message_brief_title">
                        Your brief for "{{brief.title}}"
                    </div>

                     <div class="message_brief_content">
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/search_field_1_problem_to_be_solved.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">PROBLEM TO BE SOLVED</span>
                        <div class="scouting_brief_item_content">
                          {{brief.description}}
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_assets.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Assets required</span>
                        <div class="scouting_brief_item_content">
                            <ul v-if="brief.assets">
                              <li v-for="(item, i) in brief.assets" :key='i'>+ {{item}}</li>
                            </ul>

                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_reco_techno.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">recommended technologies</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="brief.assets">
                            <li v-for="(item, i) in brief.recommended_technologies" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_benef_client.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Benefits for <span v-if="userInfo.entreprise">{{userInfo.entreprise}}</span><span v-else></span></span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="brief.company_benefits">
                            <li v-for="(item, i) in brief.company_benefits" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_indu.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">Industries</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="brief.industries">
                            <li v-for="(item, i) in brief.industries" :key='i' >+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="scouting_brief_item">
                        <img :src="require('@/assets/pearlAI_benef_end.svg')" class="scouting_brief_item_img"/>
                        <span class="scouting_brief_item_title">benefits for end customer</span>
                        <div class="scouting_brief_item_content">
                          <ul v-if="brief.customer_benefits">
                            <li v-for="(item, i) in brief.customer_benefits" :key='i'>+ {{item}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>


              </div>


              <div class="startups_lists">

                <div class="col-12 col-12 startup_selection_section">


                <div class="super_action_zone mt30">

                    <div class="quicksearch">
                          <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                    </div>
                    <div class="tooglerFilter">
                      <div class="toogler" @click="showSidePanelBasic = !showSidePanelBasic">
                          FILTER
                          <small class="nb_item" v-if="basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  > 0">{{basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  }}</small>
                          <img :src="require('@/assets/filter2024.svg')" class="" alt="">
                      </div>
                    </div>
                  </div>
                <div class="new_action_zone">
                  <div class="row">
                    <span class="numberOfStartupResult">
                      {{number_of_startups}} innovator<span v-if="number_of_startups > 1">s</span>
                    </span>
                  </div>
                    <div class=" flexItCenterButtons">
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="runassessment = true" :disabled="are_selected.length == 0">Add to assessment</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length != 2 && are_selected.length != 3) ? 'enableWhyDisabled' :'ok' ">
                        <router-link class="action_btn_pool"  :class="(are_selected.length != 2 && are_selected.length != 3) ? 'disabledRlink' :'ok' " :to="'/compare_startup_to_assess/'+this.$route.params.search_field+'/'+are_selected[0]+'/'+are_selected[1]+'/'+are_selected[2]">Compare</router-link>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 2">Please select at least 2 innovators</span>
                          <span v-if="are_selected.length > 3">You can compare 3 innovators max</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialoglist = true" :disabled="are_selected.length == 0">Add to a list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogCreateList = true" :disabled="are_selected.length == 0">Create a new list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>


                      <!-- <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRemove = true" :disabled="are_selected.length == 0">Remove</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                        </span>
                      </div> -->
                      <div class="zoneBtn">
                        <button type="button" class="selectAllCp" @click="selectAll" v-if='allSelect == false' name="button">Select All</button>

                        <button type="button" class="selectAllCp" @click="unselectAll" v-if='allSelect == true' name="button">Unselect All</button>
                      </div>
                    </div>

                </div>
                <div class="lists_innovators">


                <div class="one_list " v-if="in_db_startups_filtered.length > 0">
                  <div class="in_db_list" v-if="in_db_startups_filtered.length > 0">


                  <h3 class="one_list_title">Innovators from your database</h3>
                  <div class="col-12 zone_startups" >
                    <div class="row" >
                      <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in in_db_startups_filtered" :key="c">
                        <div class="candidate_card" :class="[(are_selected.includes(candidate._id.$oid)) ? 'isChecked' : 'notChecked']">
                          <div class="candidate_card_head">
                            <span class="name">{{candidate.name}}</span>
                            <div class="goRight">
                              <div class="selectIt">
                                <input class="checkbox__input" type="checkbox" v-model="are_selected" :value="candidate._id.$oid"/>
                                <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                  <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                  <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                                </svg>
                              </div>
                            </div>

                          </div>
                          <div class="candidate_info_content">
                            <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                            <NonStartupCardInner v-else :candidate="candidate"/>

                          </div>
                            <div class="website" v-if="candidate.website">
                               <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                            </div>
                          <div class="footer">

                            <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" class="detail">
                            Details
                            </router-link>
                          </div>


                              </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="norelevant_results" v-else>
                      No innovator matching your criterias.
                  </div>
                  <div class="action_zone_see_more" v-if="not_in_db_startups_filtered.length > 0 && show_not_in_db == false">
                      <button class="see_more_button" @click="showNotInDb()" type="button" name="button">FIND MORE INNOVATORS</button>
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                  <div class="action_zone_see_more" v-else-if="general_knowledge_startups_filtered.length > 0 && show_general_knowledge == false && show_not_in_db == false">
                      <button class="see_more_button" @click="showGeneralKnowledge()" type="button" name="button">FIND MORE INNOVATORS</button>
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                </div>
                <div class="one_list in_db_list" v-else>
                  <h3 class="one_list_title">Innovators from your database</h3>

                  <div class="norelevant_results">
                    No relevant innovators found in your database.
                  </div>
                  <div class="action_zone_see_more" v-if="not_in_db_startups_filtered.length > 0 && show_not_in_db == false">
                      <button class="see_more_button" @click="showNotInDb()" type="button" name="button">FIND MORE INNOVATORS</button>
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                  <div class="action_zone_see_more" v-else-if="general_knowledge_startups_filtered.length > 0 && show_general_knowledge == false && show_not_in_db == false">
                      <button class="see_more_button" @click="showGeneralKnowledge()" type="button" name="button">FIND MORE INNOVATORS</button>
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                </div>


                <div class="one_list" v-if="show_not_in_db && not_in_db_startups_filtered.length > 0">
                  <div class="not_in_db_list">


                  <h3 class="one_list_title">Innovators from Innopearl database</h3>
                  <div class="col-12 zone_startups" >
                    <div class="row" >
                      <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in not_in_db_startups_filtered" :key="c">
                        <div class="candidate_card" :class="[(are_selected.includes(candidate._id.$oid)) ? 'isChecked' : 'notChecked']">
                          <div class="candidate_card_head">
                            <span class="name">{{candidate.name}}</span>
                            <div class="goRight">
                              <div class="selectIt">
                                <input class="checkbox__input" type="checkbox" v-model="are_selected" :value="candidate._id.$oid"/>
                                <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                  <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                  <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                                </svg>
                              </div>
                            </div>

                          </div>
                          <div class="candidate_info_content">

                          <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                          <NonStartupCardInner v-else :candidate="candidate"/>
                          </div>
                            <div class="website" v-if="candidate.website">
                               <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                            </div>
                          <div class="footer">

                            <router-link :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" class="detail">
                            Details
                            </router-link>
                          </div>


                              </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="action_zone_see_more" v-if="general_knowledge_startups_filtered.length > 0 && show_general_knowledge == false">
                      <button class="see_more_button" @click="showGeneralKnowledge()" type="button" name="button">FIND MORE INNOVATORS</button>
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                </div>


                <div class="one_list" v-if="show_general_knowledge && general_knowledge_startups_filtered.length > 0">
                  <div class="in_db_list">


                  <h3 class="one_list_title">Other potential innovators</h3>
                  <div class="col-12 zone_startups" >
                    <div class="row" >
                      <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(candidate, c) in general_knowledge_startups_filtered" :key="c">
                        <div class="candidate_card">

                          <div class="candidate_card_head generic">
                            <div class="generic_name">
                              {{candidate.name}}
                            </div>


                          </div>
                          <div class="candidate_info_content">

                            <div class="generic_value_proposition" v-if="candidate.startup_assets || candidate.pitch">
                              <span class="vp_title">Value proposition</span>
                              <span class="vp_value" v-if="candidate.startup_assets">{{candidate.startup_assets}}</span>
                              <span class="vp_value" v-if="candidate.pitch">{{candidate.pitch}}</span>
                            </div>


                          </div>
                            <div class="website" v-if="candidate.website">
                               <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                            </div>
                            <div class="website" v-else-if="candidate.url">
                               <a :href="getHttpsUrl(candidate.url)" target="_blank">{{ getBaseUrl(candidate.url) }}</a>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="norelevant_results ither_potential subtitle mt20">
                    Interested in « Other potential innovators » ? <br/>Use « scout » and share your challenge with them.
                  </div>
                  <div class="action_zone_see_more" v-if="show_general_knowledge == true">
                      <button @click="scout()"  class="scout_button" type="button" name="button">SCOUT</button>

                  </div>
                </div>

        </div>
              </div>


        </div>

      </div>
  </div>  </div>
</template>
<script>
import api from '../tools/api';
// // import router from '@/router'
// import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import StartupCardInner from '@/components/StartupCardInner.vue'
import NonStartupCardInner from '@/components/NonStartupCardInner.vue'


import StartupRunAssessment from '@/components/StartupRunAssessment.vue'
import AddToListModal from '@/components/modals/addToListAlt.vue'
import CreateListModal from '@/components/modals/createListUser.vue'

import countries from '@/assets/flat_countries_db.json';

import { toast } from 'vue-sonner'
export default {
  components: {
    StartupCardInner,
    NonStartupCardInner,
    StartupRunAssessment,
    AddToListModal,
    CreateListModal,
  },
  name: 'WhereToInnovateResults',
  data() {
    return {
      pageInfo: {
        mainTitle : "Scouting",
        subTitle : "Find innovators",
      },
      are_selected : [],
      show_brief:false,
      pearlAI_reflexion:false,
      apiUrl: process.env.VUE_APP_API_URL,
      needs_prompt:false,
      userInfo:null,
      topicScore:null,
      messages : [],
      sessionId: null,
      debugerPeople : ["64a2ae841e94ddfc32058c76","64a2ae841e94ddfc32058c76","66277502be2623f17e040bd5","64be5de5851dc5d20da0a6b5"],
      brief:null,
      in_db_startups: [],
      not_in_db_startups:[],
      general_knowledge_startups:[],
      in_db_startups_filtered:[],
      general_knowledge_startups_filtered:[],
      not_in_db_startups_filtered:[],
      topicTitle: "",
      show_not_in_db : false,
      show_general_knowledge : false,
      runassessment:false,
      dialoglist:false,
      dialogCreateList:false,
      allSelect:false,
      number_of_startups:0,
      showSidePanelBasic:false,
      quicksearch : "",
      basicFilters: [
          {
              "key": "application_area",
              "dict": "application_areas",
              "values": [],
              "values_list": [],
              "display_name": "Application domain",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "assets",
              "values": [],
              "dict": "type_of_assets",
              "values_list": [],
              "display_name": "Assets",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "business_model",
              "values": [],
              "values_list": [],
              "display_name": "Business model",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "company_type",
              "dict": "company_type",
              "values": [],
              "values_list": [],
              "display_name": "Company type",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "data_available",
              "dict": "data_available",
              "values": [],
              "values_list": [],
              "display_name": "Data available",
              toggled: false,
              toggled_sidebar: false,
              filtre:""
          },
          {
              "key": "development_stage",
              "values": [],
              "values_list": [],
              "display_name": "Development stage",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "funding_stage",
              "values": [],
              "values_list": [],
              "display_name": "Funding Stage",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "IP",
              "values": [],
              "dict": "ip",
              "values_list": [],
              "display_name": "IP",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "innovation_area",
              "dict": "innovation_areas",
              "values": [],
              "values_list": [],
              "display_name": "Innovation area",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "product_category",
              "values": [],
              "values_list": [],
              "display_name": "Innovation category",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },

          {
              "key": "location",
              "values": [],
              "values_list": countries,
              "display_name": "Location",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "markets",
              "values": [],
              "values_list": [],
              "display_name": "Served markets",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "partnership_objectives",
              "values": [],
              "dict": "partnership_objectives",
              "values_list": [],
              "display_name": "Partnership objectives",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "revenue",
              "display_name": "Revenue",
              "values": {
                  "min": 0,
                  "max": 0,
                  "unit": "M",
                  "devise": "EUR"
              },
              toggled_sidebar: false,
          },
          {
              "key": "skills",
              "values": [],
              "values_list": [],
              "display_name": "Skills",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },
          {
              "key": "sustainability_impact",
              "values": [],
              "dict": "sustainability_impact",
              "values_list": [],
              "display_name": "Sustainability impact",
              toggled: false,
              toggled_sidebar: false,
              filtre: ""
          },



        ]

    }
  },
  methods:{
    scout(){
      var scout_url = '/link_plus?src=pearlai&lpname='+encodeURIComponent(this.topicTitle);
      if(this.brief.description){
        scout_url += "&problem_to_be_solved="+encodeURIComponent(this.brief.description)
      }
      if(this.brief.recommended_technologies){
          scout_url += "&recommended_technologies="+JSON.stringify(encodeURIComponent(this.brief.recommended_technologies));
      }
      if(this.brief.customer_benefits){
          scout_url += "&benefits_for_the_end_customers="+JSON.stringify(encodeURIComponent(this.brief.customer_benefits));
      }
      this.$router.push(scout_url);
    },
    newInternal(v){
      console.log("newInternal",v);
      var toPost = {
        assessment : v,
        startups : this.are_selected
      }
      api.post(process.env.VUE_APP_API_URL+"/restrict/createAssessmentFromPool",toPost,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success(this.$t("Innovators are included in the assessment"));
          this.runassessment = false;
          this.reloadStartupRepartition();
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.runassessment = false;
      });
    },
    newInnopearl(v){
      console.log(v);
      v.startups = this.are_selected;
      api.post(process.env.VUE_APP_API_URL+"/restrict/new_innopearl_assessment",v,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("New assessment have been asked to Innopearl Team");
              this.runassessment = false;
              this.addeddInnoAssess = true;
              this.reloadStartupRepartition();
        }).catch( (e) => {
          console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });

    },
    existingInternal(v){
      console.log("existingInternal",v);
      var toPost = {
        assessment : v,
        startups : this.are_selected
      }
      api.post(process.env.VUE_APP_API_URL+"/restrict/addMultipleStartupsToAssessment",toPost,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success(this.$t("Innovators are included in the assessment"));
          this.runassessment = false;
          this.reloadStartupRepartition();
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.runassessment = false;
      });
    },
    createList(v){
      console.log(v);
      v.candidates = this.are_selected;
      api.post(process.env.VUE_APP_API_URL+"/restrict/admin_create_list",v,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("List successfully created with selected innovators");
          this.dialogCreateList = false;
          this.reloadStartupRepartition();
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.dialogCreateList = false;
      });
    },
    toExisting(v){
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list_multiple",
          {
            poolids : v,
            candidates : this.are_selected,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        this.dialoglist =false;
    },
    getFormattedContent(content) {
      // Replace newline characters with <br> tags
      return content.replace(/\n/g, '<br>');
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },
    selectAll(){
      this.in_db_startups_filtered.forEach((item) => {
        this.are_selected.push(item._id.$oid);
      });
      if(this.show_not_in_db){
        this.not_in_db_startups_filtered.forEach((item) => {
          this.are_selected.push(item._id.$oid);
        });
      }

      this.allSelect = true;
    },
    unselectAll(){
      this.are_selected = [];
      this.allSelect = false;
    },
    showNotInDb(){
      this.show_not_in_db = true;
      this.number_of_startups = this.in_db_startups_filtered.length ?? 0;
      if(this.show_not_in_db)   this.number_of_startups += this.not_in_db_startups_filtered.length ?? 0;
      if(this.show_general_knowledge) this.number_of_startups += this.general_knowledge_startups_filtered.length ?? 0;
    },
    showGeneralKnowledge(){
      this.show_general_knowledge = true;

      this.number_of_startups = this.in_db_startups_filtered.length ?? 0;
      if(this.show_not_in_db)   this.number_of_startups += this.not_in_db_startups_filtered.length ?? 0;
      if(this.show_general_knowledge) this.number_of_startups += this.general_knowledge_startups_filtered.length ?? 0;
    },
    reloadStartupRepartition(){
      this.apply_filter();
    },
    reset_bfilter(){
      this.basicFilters.forEach((item) => {
        if(item.key != "revenue" && item.key != "submitDate"){
          item.values = [];
        }
        else{
          if(item.key == "revenue"){
            item.values = {
              "min": 0,
              "max" : 0,
              "unit": "M",
              "devise": "EUR"
            };
          }
          if(item.key == "submitDate"){
            item.values = {
              "from": null,
              "to" : null,
            };
          }

        }

      });
      this.apply_filter();
    },
    apply_filter(){

      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: false,
        toggled_sidebar: false
      }));
      this.showMatching = false;
      this.showSidePanelBasic = false;
      console.log("BASIC FILTER",this.basicFilters);
      this.loading = true;
      api.post(process.env.VUE_APP_API_URL+"/restrict/getPearlAIBrief_filters/"+this.$route.params.id,
          {
              basicFilters : this.basicFilters,
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
        console.log("POOLFILTERED",r);
        this.in_db_startups = r.data.startups_in_client_db_details;
        this.not_in_db_startups = r.data.startups_not_in_client_db_details;
        this.in_db_startups_filtered = r.data.startups_in_client_db_details;
        this.not_in_db_startups_filtered = r.data.startups_not_in_client_db_details;
        this.quicksearch = "";
        this.number_of_startups = this.in_db_startups_filtered.length ?? 0;
        if(this.show_not_in_db)   this.number_of_startups += this.not_in_db_startups_filtered.length ?? 0;
        if(this.show_general_knowledge) this.number_of_startups += this.general_knowledge_startups_filtered.length ?? 0;
      }).catch( (e) => {console.log(e);this.loading = false;});
    },
    toggleFilter(fk){
      console.log(fk);
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: (obj.key == fk )? !obj.toggled : false
      }));
      console.log(this.basicFilters);
    },
  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
    api.get(process.env.VUE_APP_API_URL+"/restrict/myaccount").then( (r) => {
      this.userInfo = r.data;
      this.$store.commit('UPDATE_ROLE',r.data.role);
      var requestarray = this.basicFilters.filter(obj => ['revenue', 'location','submitDate'].every(key => obj.key !== key));

      requestarray.forEach((item, index) => {

        var dict_key = (item.dict) ? item.dict : item.key;
        if(dict_key != 'location' && dict_key != "revenue" && dict_key != "submitDate" && dict_key != "linkplus" && dict_key != "submitDate"){
          api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_"+dict_key,{
            headers: {
                'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r.data);
            item.values_list = r.data;
            if(index == requestarray.length - 1){
              console.log("Dict loaded");

            }

          }).catch( error => {
            if(error.response.data.message) toast.error(error.response.data.message);
            else toast.error("Sorry, an error occurs. Please try again !");
          })
        }
        if(dict_key == "linkplus"){
          console.log("MOUNTED LP");
          api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            item.values_list = r.data;

      console.log("MOUNTED LP REP");
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        }
            this.linkplus_loaded = true;
      this.dict_loaded = true;
      });

      api.get(process.env.VUE_APP_API_URL+"/restrict/getPearlAIBrief/"+this.$route.params.id).then( (r) => {
        this.brief = r.data.brief;
        this.sessionId = r.data.sessionId;
        this.in_db_startups = r.data.startups_in_client_db_details;
        this.not_in_db_startups = r.data.startups_not_in_client_db_details;
        this.general_knowledge_startups = r.data.general_knowledge_startups;

        this.in_db_startups_filtered =   this.in_db_startups;
        this.not_in_db_startups_filtered = this.not_in_db_startups;
        this.general_knowledge_startups_filtered = this.general_knowledge_startups;


        this.messages = r.data.messages;
        this.topicTitle = r.data.title;
        this.topicScore = r.data.topicScore;
        this.number_of_startups = this.in_db_startups.length ?? 0;

        if(this.number_of_startups == 0){
          if(this.not_in_db_startups.length > 0){
            this.number_of_startups = this.not_in_db_startups.length ?? 0;
            this.show_not_in_db = true;
          }
          else{
            this.number_of_startups = this.general_knowledge_startups.length ?? 0;
            this.show_general_knowledge = true;
          }
        }
      }).catch( (e) => {
         console.log(e);
         toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });
    }).catch( (e) => {
       console.log(e);
       toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
    });


  },
  watch : {
    showSidePanelBasic: function(){
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: false
      }));
    },
    quicksearch: function(v){
      console.log(v);
        this.in_db_startups_filtered = this.in_db_startups.filter(obj =>{

            return obj.name.toLowerCase().includes(v.toLowerCase())

        });
        this.not_in_db_startups_filtered = this.not_in_db_startups.filter(obj =>{

            return obj.name.toLowerCase().includes(v.toLowerCase())

        });
        this.general_knowledge_startups_filtered = this.general_knowledge_startups.filter(obj =>{

            return obj.name.toLowerCase().includes(v.toLowerCase())

        });
        this.number_of_startups = this.in_db_startups_filtered.length ?? 0;
        if(this.show_not_in_db)   this.number_of_startups += this.not_in_db_startups_filtered.length ?? 0;
        if(this.show_general_knowledge) this.number_of_startups += this.general_knowledge_startups_filtered.length ?? 0;


   },
  }


}
</script>
<style scoped>
.mt20{
  margin-top:20px;
}
.where_to_innovate_finder{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
display: flex;
  flex-direction: column;
}

.firstmessage{
  margin-top:50px;
}
.title{
  color:#3783C5;
  font-size:24px;
  font-weight: 500;
  margin-top:20px;
  text-transform: uppercase;
  font-family: "Inter";
  text-align:center;
}
.subtitle{
  color:#3783C5;
  font-size:20px;
  font-weight: 500;
  font-family: "Inter";
  text-align:center;
}

.first_prompter{
  text-align: center;
  max-width: min(900px, 100%);
  position:relative;
  margin:auto;
}
.first_prompter_inside{
  position:relative;
  width:100%;
}

.my_prompt{
  border: 1px solid #3783C5;
  border-radius: 10px;
  padding: 20px;
  resize: none;
  margin-top: 20px;
  color: #04246A;
  font-size: 15px;
  width: 100%;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
  display:inline-block;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.sendPearlAiBtn{
  position:absolute;
  bottom:20px;
  right:20px;
}

.messages{

  margin-top:50px;
}

.messages .message_container{
  max-width: min(900px, 100%);
  position:relative;
  margin:auto;
}

.one_message.user .message_container .inner{
  background: #3783C5;
  padding: 25px;
  color: #FFF;
  font-size: 16px;
  border-radius: 15px;
  font-weight: 300;
  text-transform: none;
  width: 80%;
  margin-left: auto;
  margin-top:25px;
}
.one_message.brief .message_container .inner,

.one_message.topicRefined .message_container .inner,
.one_message.topic .message_container .inner,
.one_message.bot .message_container .inner{
  background:#F1F6FB;
  padding: 25px;
  color: #3783C5;
  font-size: 16px;
  border-radius: 15px;
  font-weight: 500;
  text-transform: none;
  width: 80%;
  margin-right: auto;
  margin-top:25px;
}


.ai_loader{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(0,0,0,.2);
  width: 100%;
  display: block;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.ai_loader_in{
  background: #FFF;
  padding: 20px;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-content: center;
  align-items: center;

}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ai_loader_in img{
  width:45px;
  animation: rotate 3s linear infinite;
}

.ai_loader_in .ai_loader_text{
  font-size: 18px;
  font-weight: 600;
  color:#04246A;
}

.legend_first_prompt{
  font-weight: 600;
  color:#04246A;
  text-align: left;
  display: block;
  font-size:13px;
}


.list_of_topics{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 50px;
  margin-bottom: 50px;
}

@media screen and (max-width:1600px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width:1300px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width:990px){
  .list_of_topics{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
}
.list_of_topics .one_topic{
  border: 1px solid #D1E8FB;
  border-radius: 10px;
  background: #FFF;
  padding: 30px 20px;
  position:relative;
  display: flex;
    flex-direction: column;
}

.one_topic_title{
  font-size: 15px;
  color: #3783C5;
  text-transform: uppercase;
  font-weight: 500;
}

.one_topic_desc{
  font-size: 15px;
  color: #04246A;
  margin-top: 10px;
  margin-bottom: 15px;
}
.one_topic_source{
  font-size: 13px;
  font-weight: 300;
  color: #04246A;
  margin-bottom: 25px;
}
.one_topic_action{
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: auto;
}

.refine_button{
  flex: 1;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  color: #3783C5;
}
.select_button{
  flex: 1;
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  background: #3783C5;
  color: #FFF;
}
.show_startups_button{
  border:1px solid #3783C5;
  border-radius:25px;
  padding:10px 20px;
  background:#3783C5;
  color: #FFF;
}




.message_brief{
  margin-top: 50px;
  margin-bottom: 50px;
  text-align: center;
  font-size: 22px;
  color:#04246A;
  font-weight: 600;
}

.message_brief_content{
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;
  margin-top: 50px;
  margin-bottom: 50px;
  width: min(1500px,100%);
  margin-left: auto;
  margin-right: auto;
}


@media screen and (max-width:1200px){
  .message_brief_content{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap:50px;
  }
}
.scouting_brief_item{
  width: 100%;
border: 1px solid #DDD;
border-radius: 10px;
position: relative;
}
.scouting_brief_item_img{
  width: 55px;
position: absolute;
top: -25px;
left: -25px;
}
.scouting_brief_item_title{
  position: absolute;
top: 0;
left: 50px;
background: #FFF;
transform: translateY(-50%);
padding-left: 10px;
padding-right: 10px;
padding-top: 6px;
padding-bottom: 6px;
font-size: 18px;
line-height: 18px;
font-weight: 600;
color: #3783C5;
text-transform: uppercase;
}

.scouting_brief_item_content{
  padding: 50px;
  font-size:16px;
  font-weight: 300;
  color:#000;
  text-align:left;
}
.header.withDataRoom{
  width:100%;
  display:block;
  margin-bottom: 25px;
}
.goToDataroom{
  background: #3783C5;
  color:#FFF;
  padding:10px 20px;
  float:right;
  display:flex;
  align-items: center;
  gap:10px;
  font-size:12px;
  text-transform: uppercase;
  border-radius:50px;
  font-weight: 500;
}

.goToDataroom .dataroom_size{
  background:#115AA4;
  padding:2px;
  border-radius: 50%;
  width:25px;
  height:25px;
  display:flex;
  font-size:12px;
  justify-content: center;
  align-items: center;
}

.scouting_brief_item_content ul,
.scouting_brief_item_content ul li{
  list-style-type: none;
  padding-left:0px;
}

.actions_on_brief{
  display:flex;
  justify-content: flex-end;
  align-items: flex-end;
  width:100%;
}

.main_action_zone{
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;
  gap:20px;
}

.see_the_brief_button{
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  color: #3783C5;
  padding:10px 20px;
}
.zone_startups{
    align-self: center;
}

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
  background:#FFF;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}
.checkboxItem{
  margin-bottom: 20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }

    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }

}


.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;

  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}

.candidate_card_head .name{
  flex:1;
}

.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.website a{
  color:#4c81c0 !important;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}

.candidate_card.isChecked{
  border-color:#4C81C0;
}
.candidate_card.isChecked .checkbox__icon .fond{
  fill:#FFF !important;
}

.one_list_title{
  color:#04246A;
  font-size:22px;
  font-weight: 600;
  line-height: 26px;
  text-align:center;
}

.in_db_list{
  background:#F1F6FC;
  border-radius:16px;
  padding:50px;
}

.not_in_db_list{
  background:#fff;
  border-radius:16px;
  padding:50px;
}

.action_zone_see_more{
  display:flex;
  gap:15px;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top:20px;
}

.action_zone_see_more .see_more_button{
  border: 1px solid #3783C5;
  border-radius: 25px;
  padding: 10px;
  background: #3783C5;
  color:#FFF;
  padding:10px 20px;
}

.full_action{
  display:flex;
  justify-content:center;
  flex-wrap:wrap;
  align-items:center;
  margin-top:50px;
}
.scout_button{
 border: 1px solid #3783C5;
 border-radius: 25px;
 padding: 10px;
 background: #fff;
 color:#3783C5;
 padding:10px 20px;
 text-transform:uppercase;
}

.startups_lists{
  display: flex;
  flex-direction: column;
  gap:50px;
}




.candidate_card_head.generic{
  background: #FFF;

  padding: 10px;
  padding-left: 20px;
  color: #4B81C0;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}


.generic_name{
font-size: 16px;
}

.generic_value_proposition{
  display:flex;
  flex-direction: column;
  color:#0B1F72;
}
.generic_value_proposition .vp_title{
font-weight: 200;
}
.generic_value_proposition .vp_value{
font-weight: 500;

}


.topicInfo{
  display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
    gap:10px;
}
.tt_label{
  text-transform: uppercase;
  font-size:13px;
  color:#04246A;
  font-weight:500;
}
.tt_value{
  text-transform: uppercase;
  font-size:13px;
  color:#3783C5;
  font-weight:500;
}


.one_topic_interest.low{
  background:#FFE2E5;
  padding:4px 10px;
  font-size:13px;
  font-weight: 700;
  color:#FA5A7D;
  border-radius:20px;
}
.one_topic_interest.medium{
  background:#FFF4DE;
  padding:4px 10px;
  font-size:13px;
  font-weight: 700;
  color:#FFAA2A;
  border-radius:20px;
}
.one_topic_interest.high{
  background:#E7FFEF;
  padding:4px 10px;
  font-size:13px;
  font-weight: 700;
  color:#3AC851;
  border-radius:20px;
}


.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.new_action_zone {
  position: sticky;
    right: 0;
    top: 0;
    z-index:889;
    background:#FFF;
    padding-top:20px;
    padding-bottom: 20px;
    margin-top:25px;
}

.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 200px;
}



.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}



[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
  margin-right: auto;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}



    .numberOfStartupResult{
      text-align:center;
    font-size: 21px;
    line-height:25px ;
letter-spacing: 0px;
color: rgba(55, 131, 197, 1);
text-transform: uppercase;
    }

    .flexItCenterButtons{
      width:100%;
      display:flex;
      justify-content: center;
      align-items: center;
      gap:10px;
      margin-top:20px;
          flex-wrap: wrap;
    }


    .action_btn_pool,
    .action_btn_pool:hover{
      background: rgba(55, 131, 197, 1);
      border:1px solid rgba(55, 131, 197, 1);
      color: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
    }

    .disabledRlink{
      pointer-events: none;
      opacity: 0.7;
    }
    .selectAllCp{
      color: rgba(179, 141, 47, 1);
      border:1px solid rgba(179, 141, 47, 1);
      background: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
      margin-top:0px;
    }


    .zoneBtn{
      position:relative;
      display: flex;
    width:auto;

    }
    @media screen and (max-width:990px){
      .new_action_zone {
        position: relative;

          z-index:1;
          background:#FFF;
          padding-top:20px;
          padding-bottom: 20px;
      }
      .quicksearch{
        max-width: 100%;
        width:100%;
        margin-top:20px;
        margin-bottom:20px;
      }
      .quicksearch .input{
        max-width: 100%;
        width:100%;
          /* border: 1px solid #fff;
          background: transparent;
          padding: 5px 20px;
          border-radius: 200px;
          outline: none;
          color: #fff;
          font-weight: bold;
          letter-spacing: 1px; */
      }
      .filtre_list_2{
        width:100%;
        flex:1;
      }

      .target_score_container .slider_mini_score{
        flex-direction: column !important;
      }
      .flexItCenterButtons{
        flex-direction: column;

      }
      .whyDisabled{
        z-index: 9999;
      }
    }

    .startup_notice_info{
      display:block;
      width:100%;
      text-align:center;
    }


    .sidePannel{
      position: fixed;
      right: 0;
      width: min(100%,500px);
      background: #FFF;
      top: 0;
      height: 100vh;
      z-index: 999;
      overflow: scroll;

    }

    .oneFilter{
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .oneFilter:not(:last-child){
    border-bottom: 1px solid #ddd;
    }
    .oneFilter .filtreName{
      margin-bottom:10px;
      display:block;
      color:#4c81c0;
    }
    .oneFilter .value_possible{
      max-height:300px;
      overflow: scroll; /* Always show both horizontal and vertical scrollbar */
        scrollbar-width: thin; /* Firefox */
        scrollbar-color: #333 #fff; /* Firefox */
    }

    .oneFilter .value_possible::-webkit-scrollbar {
          width: 12px; /* Width of the scrollbar */
        }

    .oneFilter .value_possible::-webkit-scrollbar-thumb {
          background-color: #333; /* Color of the thumb */
        }
    .oneFilter .value_possible::-webkit-scrollbar-track {
          background-color: #fff; /* Color of the track */
        }

        .sidePannel .filters{
          overflow: scroll;
      padding: 30px;
      height: calc(100vh - 100px);
        }

      .sidePannel .create_filters{
        overflow: scroll;
    padding: 30px;
    height: calc(100vh);
      }
        .footerPannel{
          position: static;
      height: 100px;
      border-top: 2px solid #4c81c0;
      padding:20px;
      text-align:right;
        }

          .footerPannel .btn{
          padding:5px 10px;
          background:#4c81c0;
          color:#FFF;
          font-size:15px;
          border-radius: 20px;
          border:1px solid #4C81C0;
          margin:10px;
        }

        .footerPannel .btn_invert{
        padding:5px 10px;
        color:#4c81c0;
        background:#FFF;
        font-size:15px;
        border-radius: 20px;
        border:1px solid #4C81C0;
        margin:10px;
      }
      .triangle{
        width:15px;
      }

      .triangle.open{
        transform:rotate(180deg);
      }




        .quicksearch{
          position:relative;
        }
        .quicksearch .input{
          max-width:300px;
            border: 1px solid #3783C5;
            background: transparent;
            padding: 10px 20px;
            padding-right: 50px;
            border-radius: 200px;
            outline: none;
            color: #3783C5;
            font-weight: bold;
            letter-spacing: 1px;
        }
        .quicksearch::after{
          content: url('@/assets/loupe.svg');
          position:absolute;
          right:15px;
          top:50%;
          transform:translateY(-50%);
        }



        @media screen and (max-width:990px){
          .quicksearch{
            max-width: 100%;
            width:100%;
            margin-top:20px;
            margin-bottom:20px;
          }
          .quicksearch .input{
            max-width: 100%;
            width:100%;
              /* border: 1px solid #fff;
              background: transparent;
              padding: 5px 20px;
              border-radius: 200px;
              outline: none;
              color: #fff;
              font-weight: bold;
              letter-spacing: 1px; */
          }
          .filtre_list_2{
            width:100%;
            flex:1;
          }

          .target_score_container .slider_mini_score{
            flex-direction: column !important;
          }
          .flexItCenterButtons{
            flex-direction: column;

          }
          .whyDisabled{
            z-index: 9999;
          }
        }

        .mt30{
          margin-top:30px;
        }
        .super_action_zone{
          padding: 20px 30px;
          z-index:889;
          display:flex;
          flex-wrap:wrap;
          background: rgba(55, 131, 197, .07);
        border-radius: 200px;
        margin-right: 20px;
        margin-left: 20px;
        display:flex;
        align-items: center;
        justify-content: space-between;
        }

        @media screen and (max-width:690px){
            .super_action_zone{flex-direction: column;gap:20px;    padding: 10px;}
          .quicksearch{
            margin-top:20px;
          }
          .quicksearch .input{
            max-width: 100%;
            width:100%;

          }
          .filtre_list_2{
            width:100%;
            flex:1;
          }
        }

        .lists_innovators{
          display:flex;
          flex-direction:column;
          gap:50px;
          margin-top:25px;
        }

        .nb_item{
          background: #B38D2F;
          padding: 2px 10px;
          border-radius: 5px;
          font-size: 10px;
          color:#FFF;
          vertical-align: middle;
          margin-right: 5px;
        }
        @media screen and (max-width:990px){
          .where_to_innovate_finder{
            padding-left:10px;
            padding-right:10px;
          }
          .where_to_innovate_finder .content_div{
            padding-left:20px;
            padding-right: 20px;
          }
          .super_action_zone{
            border-radius:20px;
          }
          .in_db_list,
          .not_in_db_list{
            padding-left:20px;
            padding-right: 20px;
          }
        }


        .footer a.detail{
          background:#F1F6FC;
          padding:6px 12px;
          border-radius:50px;
            font-size: 12px;
        }

        .norelevant_results{
          width:100%;
          font-weight:500;
          text-transform:uppercase;
          text-align:center;
          margin-top:40px;
        }

        .ither_potential{
            text-transform:none;
            color: #0b1f72;

            border-radius: 10px;
            font-size:18px;
        }

.messagepromopubContainerBandeau{
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 0px;
  text-align: center;
  background: #1368b2;
  color: #FFF;
  padding: 12px;
}
.messagepromopubContainerBandeau a:hover{
  color:inherit !important;
}
        .messagepromopubContainer{
          display:flex;
          justify-content: flex-end;
          width:100%;
          margin-bottom:10px;
          text-align:center;
        }
        @media screen and (max-width:990px){
          .messagepromopubContainer{
            display:flex;
            justify-content: center;
              margin-bottom:20px;
          }
        }
            .bluehover{
              color:inherit;
            }
            .bluehover:hover{
              color:#3783C5;
            }
</style>
<style media="screen" >
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }
  .v-slider-track__background--opacity {
    opacity: 1;
  }




</style>
